import React, { useEffect } from "react";
import Breadcrumb from "../../Component/Breadcrumb";

import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import $ from "jquery";
import GoogleMapSection from "../../Component/GoogleMapSection";
import { Link } from "react-router-dom";
import ContactFormEnquery from "../../Component/ContactCMPT/ContactFormEnquery";

export default function Contact() {
  const { webSetting, Pagemetatags } = useAuth();
  useEffect(() => {
    function concactStyleSwitcher() {
      if ($(".contact-section-wrapper .contact-switcher").length) {
        var btns = $(".contact-switcher .button"),
          mapSection = $(".contact-section-wrapper .map-wrapper"),
          contactSection = $(".contact-section-wrapper .contact-block");

        // ✅ Initially hide map and show form
        contactSection.removeClass("hide-content").addClass("active");
        mapSection.addClass("hide-content");
        mapSection.find(".overlay").removeClass("hide-content");

        // ✅ Ensure "Form" button is active by default
        $(".contact-switcher .button[data-style='0']").addClass("active");
        $(".contact-switcher .button[data-style='1']").removeClass("active");

        btns.off("click").on("click", function () {
          var $this = $(this);
          if (!$this.hasClass("active")) {
            $this.addClass("active");
            $this.parent().siblings().find(".button").removeClass("active");

            if ($this.attr("data-style") === mapSection.attr("data-style")) {
              // Show map
              mapSection.removeClass("hide-content");
              mapSection.find(".overlay").addClass("hide-content");
              contactSection.addClass("hide-content");
            } else if (
              $this.attr("data-style") === contactSection.attr("data-style")
            ) {
              // Show form
              contactSection.removeClass("hide-content");
              mapSection.find(".overlay").removeClass("hide-content");
              mapSection.addClass("hide-content");
            }
          }
          return false;
        });
      }
    }

    concactStyleSwitcher();
  }, []); // ✅ run only once after mount

  return (
    <>
      <Helmet>
        <title>{Pagemetatags.contacttitle}</title>
        <meta name="description" content={Pagemetatags.contactdescription} />
        <meta name="keywords" content={Pagemetatags.contactkeyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Contact" mainpage="" />

      {/* <section className="contact-section-3 fix section-padding">
        <div className="container">
          <div className="contact-info-wrapper">
            <div className="section-title text-center">
              <h2>Contact Us</h2>
              <p className="mt-3 text-center">
                Schedule a tour today and explore our fully furnished homes.
                Experience stylish, move-in-ready spaces designed for <br />{" "}
                comfort, convenience, and modern living. Let us help you find
                your perfect fit.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-12 mt-5">
              <div className="contact-wrapper-10">
                <div className="section-title text-center mb-0">
                  <h2 className="wow fadeInUp aboutSectiontitle">
        
                    Keep In Touch{" "}
      
                  </h2>
            
                </div>
             
                <ContactFormEnquery />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 mt-5">
              <div className="contacksidebox">
                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="content">
                    <h3>Location</h3>
                    <p className="text-start mb-2">
                      <b>Pune Office : </b> {webSetting?.address || ""}
                    </p>
                    <p className="text-start">
                      <b>Gwalior Office : </b> {webSetting?.address2 || ""}
                    </p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-phone-xmark"></i>
                  </div>
                  <div className="content">
                    <h3>Phone</h3>
                    <p>
                      <Link
                        to={`tel:+91${webSetting?.number || ""}`}
                        className="me-3"
                      >
                        +91 {webSetting?.number || ""}
                      </Link>
                      <span>|</span>
                      <Link
                        to={`tel:+91${webSetting?.number || ""}`}
                        className="ms-2"
                      >
                        +91 {webSetting?.number2 || ""}
                      </Link>
                    </p>
                    <p className=""> </p>
                  </div>
                </div>

                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fa-solid fa-envelopes"></i>
                  </div>
                  <div className="content">
                    <h3>Email</h3>
                    <p className="">
                      {" "}
                      <Link
                        to={`mailto:${webSetting?.email || ""}`}
                        className="me-2"
                      >
                        {webSetting?.email || ""}
                      </Link>
                      <span>|</span>
                      <Link
                        to={`mailto:${webSetting?.email2 || ""}`}
                        className="me-2"
                      >
                        {webSetting?.email2 || ""}
                      </Link>
                    </p>
                    <p className=""></p>
                  </div>
                </div>
                <div className="contact-info-box">
                  <div className="icon">
                    <i className="fab fa-whatsapp"></i>
                  </div>
                  <div className="content">
                    <h3>Whatsapp</h3>
                    <p className="">
                      {" "}
                      <Link
                        target="_blank"
                        to={`https://wa.me/+91${
                          webSetting?.whatsaap || ""
                        }?text=Hi, I would like to speak to a Bhadorva Infra`}
                        className="me-2"
                      >
                        +91 {webSetting?.whatsaap || ""}
                      </Link>
                    </p>
                    <p className=""></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <GoogleMapSection /> */}

      <section className="contact-page contact-section-wrapper bg_section section-padding">
        <div className="contact-section">
          <div className="map-wrapper" data-style="1">
            <div className="overlay"></div>
            <div className="map">
              <GoogleMapSection />
            </div>
          </div>
          <div className="container contact-block active" data-style="0">
            <div className="row">
              <div className="col col-xs-12">
                <h2>
                  Contact our support guys or make appointment with our
                  consultants
                </h2>
                <div className="contact-info">
                  <p>
                    Please contact us using the information below. For
                    additional information on our management consulting
                    services, please visit the appropriate page on our site.
                  </p>
                  <ul>
                    <li>
                      <span className="icon">
                        <i className="fi fa fa-map-marker"></i>
                      </span>
                      {webSetting?.address || ""}
                      {/* <b>Gwalior Office : </b> {webSetting?.address2 || ""} */}
                    </li>
                    <li>
                      <span className="icon">
                        <i className="fi flaticon-telephone"></i>
                      </span>
                      <Link
                        to={`tel:+${webSetting?.number || ""}`}
                        className="me-3"
                      >
                        + {webSetting?.number || ""}
                      </Link>
                    </li>
                    <li>
                      <span className="icon">
                        <i className="fi flaticon-mail-black-envelope-symbol"></i>
                      </span>
                      <Link
                        to={`mailto:${webSetting?.email || ""}`}
                        className="me-2"
                      >
                        {webSetting?.email || ""}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="contact-form">
                  <ContactFormEnquery />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-switcher">
          <ul>
            <li>
              <button data-style="1" className="button ">
                <i className="fi flaticon-location"></i> Map
              </button>
            </li>
            <li>
              <button data-style="0" className="button active">
                <i className="fi flaticon-forms"></i> Form
              </button>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}
